import type React from 'react'

export const BLUE = '#4f46e5'

export const inputStyle: React.CSSProperties = {
  width: '100%', padding: '9px 12px',
  border: '1px solid #d1d5db', borderRadius: 7,
  fontSize: 14, color: '#111827', background: 'white',
  boxSizing: 'border-box', outline: 'none',
}
